import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";
import {addProduct} from "./actions";
import {getCategoryTree} from "../Category/actions";
import {getSuppliers} from "../Supplier/actions";
import {Button, Card, Form, Icon, Input, Select, Table, Upload} from "antd";
import {formItemLayout} from "../utils/style";
import uuid from "uuid/v4";
import SelectCategoryTree from "../Category/SelectCategoryTree";

import './ImportProductsPage.css';

// eslint-disable-next-line react/prop-types
const Status = ({value}) => {
  let type, color;
  switch (value) {
    case Statuses.Added:
      type = "check-circle";
      color = "#52c41a";
      break;
    case Statuses.Error:
      type = "close-circle";
      color = "#ff0000";
      break;
    case Statuses.Existing:
      type = "exclamation-circle";
      color = "#ff7700";
      break;
    default:
      return '';
  }
  return <Icon type={type}
               theme="twoTone"
               twoToneColor={color} />;
};

class ImportProductsPage extends Component {
  static propTypes = {
    // action
    addProduct: PropTypes.func.isRequired,
    getCategoryTree: PropTypes.func.isRequired,
    getSuppliers: PropTypes.func.isRequired,
    // data
    loading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    salonId: PropTypes.string.isRequired,
    categoryTree: PropTypes.object.isRequired,
    suppliers: PropTypes.array.isRequired,
  };
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      columns: [],
      readingFile: false,
      tableColumns: [
        {
          title: '',
          dataIndex: '$status',
          key: '$status',
          render: value => (<Status value={value} />),
        },
        {
          className: 'import-products-columns',
          title: 'Order Code',
          dataIndex: 'supplierOrderCode',
          key: 'supplierOrderCode',
        },
        {
          className: 'import-products-columns',
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          className: 'import-products-columns',
          title: 'Description',
          dataIndex: 'description',
          key: 'description',
        },
        {
          className: 'import-products-columns',
          title: 'SKU',
          dataIndex: 'sku',
          key: 'sku',
        },
      ],
      columnMapping: {},
      importReady: false,
      adding: false,
      page: 1,
    };
  }

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.salonId !== prevProps.salonId) this._load();
  }

  render() {
    const {categoryTree, suppliers, form: {getFieldDecorator, getFieldsError, resetFields}, loading} = this.props;
    const {data, columns, tableColumns, readingFile, importReady, columnMapping, page, adding} = this.state;
    const onTableChange = () => {
      const fields = [];
      for (let i = 0; i < 10; i++) {
        for (let j = 0; j < tableColumns.length; j++) {
          fields.push(`products_${i}_${j}`);
        }
      }
      resetFields(fields);
    };
    const saveField = (index, field) => (e) => {
      const key = columnMapping[field] || field;
      this.setState(prevState => ({
        data: prevState.data.map((row, rowIndex) => index === rowIndex ? {...row, [key]: e.target.value} : row),
      }));
    };
    const tableColumnWithRenderers = tableColumns.map((col, colIndex) => ({
      ...col,
      title: () => col.title && (
        <React.Fragment>
          {col.title}
          <Select
            placeholder="Select mapping"
            onChange={value => this.setState(prevState => {
              const newColumnMapping = {
                ...prevState.columnMapping,
                [col.key]: value,
              };
              return {
                tableColumns: prevState.tableColumns.map((col2) => ({
                  ...col2,
                  dataIndex: col.key === col2.key ? value : col2.dataIndex,
                })),
                columnMapping: newColumnMapping,
                importReady: Object.values(newColumnMapping).length === 4,
              };
            })
            }
            value={columnMapping[col.key]}
            disabled={columns.length === 0}
          >
            {columns.map(column =>
              <Select.Option key={column} value={column}>{column}</Select.Option>
            )}
          </Select>
        </React.Fragment>
      ),
      render: colIndex === 0
        ? col.render
        : (value, {lineNumber}, index) =>
          getFieldDecorator(`products_${index}_${colIndex}`, {initialValue: value})(
            <Input
              onPressEnter={saveField(lineNumber - 1, col.key)}
              onBlur={saveField(lineNumber - 1, col.key)}
              disabled={columnMapping[col.key] === undefined || adding}
            />
          ),
    }));
    return (
      <Card title="Import Products">
        <Form onSubmit={e => e.preventDefault()}>
          <Form.Item
            {...formItemLayout}
            label="Supplier"
          >
            {getFieldDecorator('supplierId', {
              initialValue: null,
              rules: [{
                required: true,
                message: 'Supplier is required'
              }]
            })(
              <Select>
                <Select.Option key="addProduct-supplierId-null" value={null}>NONE</Select.Option>
                {suppliers.map(supplier =>
                  <Select.Option key={supplier.supplierId} value={supplier.supplierId}>{supplier.name}</Select.Option>
                )}
              </Select>
            )}
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="Default Category"
          >
            {getFieldDecorator('categoryId', {
              initialValue: null,
              rules: [{
                required: true,
                message: 'Category is required'
              }]
            })(
              <SelectCategoryTree tree={categoryTree} hideNone />
            )}
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="File"
          >
            <Upload beforeUpload={this._fileBeforeUpload.bind(this)} showUploadList={false}>
              <Button icon='plus'>Select File</Button>
            </Upload>
          </Form.Item>
          <Table
            loading={readingFile}
            dataSource={data}
            rowKey="lineNumber"
            size="small"
            columns={tableColumnWithRenderers}
            onChange={onTableChange}
            pagination={{current: page, onChange: (page) => this.setState({page})}}
          />
          <Form.Item>
            <Button.Group>
              <Button
                type="primary"
                htmlType="button"
                disabled={loading || hasErrors(getFieldsError()) || !importReady}
                onClick={this._onImportClick.bind(this)}
              >
                Import
              </Button>
              <Button
                htmlType="button"
                onClick={() => this.props.history.goBack()}
                disabled={adding}
              >
                Cancel
              </Button>
            </Button.Group>
          </Form.Item>
        </Form>
      </Card>
    );
  }

  _load() {
    const {salonId} = this.props;
    this.props.getCategoryTree({salonId});
    this.props.getSuppliers({salonId});
  }

  async _onImportClick() {
    const {addProduct, salonId} = this.props;
    const {data, columnMapping} = this.state;
    this.props.form.validateFields(async(err, {categoryId, supplierId}) => {
      if (err) return;
      this.setState({adding: true});
      for (let i = 0; i < data.length; i++) {
        let status;
        const row = data[i];
        try {
          await addProduct({
            salonId,
            productGuid: uuid(),
            categoryId,
            supplierId,
            name: row[columnMapping['name']],
            description: row[columnMapping['description']],
            salePrice: 0,
            packageQuantity: 1,
            unit: 'each',
            initialSku: row[columnMapping['sku']],
            supplierOrderCode: row[columnMapping['supplierOrderCode']],
            brandId: null,
            imageUri: '',
            limitValue: 0,
            rejectSkuDuplicate: true,
          });
          status = Statuses.Added;
        } catch (err) {
          const isExisting = err.message.includes('409');
          if (!isExisting) {
            console.error(err);
          }
          status = isExisting ? Statuses.Existing : Statuses.Error;
        } finally {
          this.setState(prevState => ({
            data: prevState.data.map((x, j) => (j === i ? {...x, $status: status} : x)),
            page: Math.floor(i / 10) + 1,
          }));
        }
      }
    });
  }

  _fileBeforeUpload(file) {
    if (file.type !== 'text/csv') return false;
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      const data = [];
      const lines = reader.result.split('\n');
      const columns = lines[0].split(',');
      for (let i = 1; i < lines.length; i++) {
        const lineData = lines[i].split(',').reduce((acc, column, index) => {
          acc[columns[index]] = column;
          return acc;
        }, {});
        if (Object.values(lineData).some(x => !x)) continue;
        data.push({...lineData, lineNumber: i, $status: Statuses.None});
      }
      this.setState({data, columns, readingFile: false, columnMapping: {}});
    };
    this.setState({readingFile: true});
    return false;
  }
}

const Statuses = {
  None: 0,
  Added: 1,
  Existing: 2,
  Error: 3,
};

const hasErrors = (fieldsError) => Object.keys(fieldsError).some(field => fieldsError[field]);

const mapStateToProps = state => ({
  loading: state.supplier.gettingSuppliers || state.product.addingProduct,
  salonId: state.salon.selectedSalonId,
  categoryTree: state.category.categoryTree,
  suppliers: state.supplier.suppliers,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  addProduct,
  getCategoryTree,
  getSuppliers,
}, dispatch);

const ImportProductsForm = Form.create()(ImportProductsPage);

export default connect(mapStateToProps, mapDispatchToProps)(ImportProductsForm);



// WEBPACK FOOTER //
// ./src/Product/ImportProductsPage.js